

   //// custom function for generate random key
 function randomString(length, chars) {
    chars = chars.toString();
    var result = "";
    for (var i = 0; i < length; i++) {
      var string = chars
        .split("")
        .sort(function () {
          return 0.5 - Math.random();
        })
        .join("");
      result += string[0];
    }
    return result;
  }

  export default function getRandomkeys() {
    return (
      "S2D" +
      "-" +
      randomString(12, "123456789") +
      "-" +
      randomString(2, "QUOTE")
    );
  }